import { isPendingBankPayment, useGetPaymentMethods } from '~/domain/Payments';
import { useIsParentOfficeSelector } from '~/hooks/useIsParentOfficeSelector';

/** @param officeId - the location Billing Details was opened for; the selected office when omitted */
export const usePendingAchBannerVisible = (officeId?: string) => {
  const { paymentMethods } = useGetPaymentMethods(officeId);
  const isParentOffice = useIsParentOfficeSelector(officeId);
  return !isParentOffice && paymentMethods.some(isPendingBankPayment);
};
